import { getQueuedDetails } from "../../helpers/fetching";

export default {
  state: {
    queuedData: false,
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setQueuedLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setResponse(state, data) {
      state.response = data;
    },
    setQueued(state, data) {
      state.queuedData = data;
      state.loading = false;
      state.error = null;
    },
    setResetQueued(state) {
      state.queuedData = [];
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    gluedChange({ commit }, value) {
      commit("clearError");
      commit("setQueuedLoading", true);
      commit("setQueued", value);
    },
    fetchQueuedDetails({ commit }, value) {
      commit("setQueuedLoading", true);
      getQueuedDetails(value)
        .then((response) => {
          commit("setQueued", response);
          commit("setQueuedLoading", false);
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
    resetQueued({ commit }) {
      commit("setResetQueued");
    },
  },
};
